<template>
  <div>
    <TopBar :pagetitle="title" :back-url="backurl" />
    <div v-for="item in list" :key="item.crossId" class="rect" @click="onSelect(item)">
      <van-row>
        <van-col span="12" class="time">{{ formatDate(item.createTime,'yyyy-MM-dd hh:mm:ss',true) }}</van-col>
        <van-col span="12" class="time textRight mainColor">   {{ GetEnumText('Em_CrossCertificationVerifyType',item.verifyType) }}</van-col>
      </van-row>
      <div class="body">
        <div class="old title">
          {{ item.oldOrganizationName }}
        </div>
        <div class="old">
          {{ item.oldLevel }}
        </div>
        <div class="old">
          {{ item.oldCertificateId }}
        </div>
        <div class="line"><img src="/img/line.png"></div>
        <div class="new title">
          SSI
        </div>
        <div class="new">
          {{ item.courseName }}
        </div>
        <div class="new">
          OBA.{{ item.oldOrganizationCode }}.{{ item.oldCertificateId }}
        </div>
        <div v-if="item.verifyTime" class="verify">
          <div class="old">审核时间:{{ formatDate(item.verifyTime,'yyyy-MM-dd hh:mm:ss',true) }} </div>
          <div class="old">审核备注:{{ item.verifyBody }} </div>
        </div>
      </div>
    <!--
      <van-row class="top">
        <van-col span="12"> {{ formatDate(item.createTime,'yyyy-MM-dd hh:mm:ss',true) }}</van-col>
        <van-col span="12" class="textRight mainColor"> {{ GetEnumText('Em_CrossCertificationVerifyType',item.verifyType) }}</van-col>
      </van-row>

      <van-row class="bodys">
        <van-col span="11" class="aboutStr">
          {{ item.oldOrganizationName }}
        </van-col>
        <van-col span="2" />
        <van-col span="11">
          SSI<br>
        </van-col>
      </van-row>

      <van-row class="bodys">
        <van-col span="11" class="aboutStr">
          {{ item.courseName }}
        </van-col>
        <van-col span="2"><i class="iconfont iconright" /></van-col>
        <van-col span="11">
          {{ item.courseName }}
        </van-col>
      </van-row>

      <van-row class="bodys">
        <van-col span="11" class="aboutStr">
          {{ item.oldCertificateId }}
        </van-col>
        <van-col span="2" />
        <van-col span="11" style="word-break:break-all;">
          OBA.{{ item.oldOrganizationCode }}.{{ item.oldCertificateId }}
        </van-col>
      </van-row>

      <div v-if="item.verifyTime" class="verify aboutStr">
        审核时间:{{ formatDate(item.verifyTime,'yyyy-MM-dd hh:mm:ss',true) }}<br>
        审核备注:{{ item.verifyBody }}
      </div> -->
    </div>
    <div class="emptyRect" />
    <div class="downButton">
      <van-button type="info" :loading="loadingButton" square @click="onAddCross">{{ canUse?'申请交叉认证':'上传头像照片' }}</van-button>
    </div>

  </div></template>
<script>
import request from '@/utils/request'
import TopBar from '@/components/TopBar'
import Cookies from 'js-cookie'
import { initPage, getUrlKey, formatDate, GetEnumText, MyNotify } from '@/utils/base'
import { Button, Dialog } from 'vant'
export default {
  components: {
    [Button.name]: Button,
    [Dialog.name]: Dialog,
    TopBar
  },
  data() {
    return {
      title: '交叉认证',
      backurl: '/textbook/license',
      list: [],
      loadingButton: true,
      canUse: false
    }
  },

  created() {
    initPage()
    var url = getUrlKey('backurl')
    if (url !== null) {
      this.backurl = url
      Cookies.set('crossCertificationList_backurl', url)
    } else if (Cookies.get('crossCertificationList_backurl')) {
      this.backurl = Cookies.get('crossCertificationList_backurl')
    }
    this.init()
  },
  methods: {
    formatDate,
    GetEnumText,
    init() {
      this.checkUserIcon((haveIcon) => {
        if (haveIcon) {
          request({
            url: '/Activity/getCrossCertificationList',
            method: 'post'
          }).then(response => {
            if (!response.success) {
              return
            }
            this.canUse = true
            this.loadingButton = false
            this.list = response.data
          })
        } else {
          Dialog.confirm({
            title: '尚未上传头像',
            message: '您尚未上传头像，制作证书需要您的头像，请先上传您的头像!'
          }).then(() => {
            this.$router.replace('/users/changeIcon?backurl=/textbook/crossCertificationList')
          }).catch(() => {
            this.loadingButton = false
          })
        }
      })
    },
    onSelect(item) {
      if (item.verifyType === 'VERIFYING') {
        MyNotify('info', '您提交的交叉认证申请正在审核中,不能修改资料!')
        return
      }
      if (item.verifyType === 'PASS') {
        MyNotify('info', '您提交的交叉认证申请已经通过!')
        return
      }
      this.$router.replace('/textbook/crossCertification/' + item.crossId + '?backurl=/textbook/crossCertificationList')
    },
    onAddCross() {
      if (this.canUse) {
        this.$router.replace('/textbook/crossCertification/0?backurl=/textbook/crossCertificationList')
      } else {
        this.$router.replace('/users/changeIcon?backurl=/textbook/crossCertificationList')
      }
    },
    checkUserIcon(callback) {
      request({
        url: '/User/getUserHaveIcon',
        method: 'post'
      }).then(response => {
        if (!response.success) {
          return
        }
        if (callback) {
          callback(response.data)
        }
      })
    }
  }
}
</script>
<style scoped>
.rect{

    /* background-color: #fff;
    border-top: 1px solid #dadada;
    border-bottom: 1px solid #dadada; */
     font-size: 0.9em;
}
.rect .time{
  line-height: 3.5em;
  padding: 0 1em;
}
.rect .body{
  padding: 1em;
  background-color: #fff;
}
.rect .old{
  color: #999;
  margin:0.5em 0;
}
.rect .new{
  margin:0.5em 0;
}
.rect .title{
  font-weight: 700;
}
.rect .verify{
  margin-top: 1.5em;
  padding-top: 1em;
  border-top: 1px solid #dadada;
}
.rect .line img{
  width: 100%;
}
/* .rect .top{

}

.rect .bodys{
    margin: 0.5em 0;
}
.rect .verify{

} */
.downButton{
    position:fixed;
    z-index: 2;
    left: 0;
    bottom: 0;
    width: 100%;
}
.downButton button{
    width: 100%;
}
.emptyRect{
    height: 3em;
}
</style>
